import { render } from "./searchPill.vue?vue&type=template&id=70bb1ed2&scoped=true"
import script from "./searchPill.vue?vue&type=script&lang=js"
export * from "./searchPill.vue?vue&type=script&lang=js"

import "./searchPill.vue?vue&type=style&index=0&id=70bb1ed2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70bb1ed2"]])

export default __exports__